import { useEffect } from 'react';

export default function useMobileAddressBar() {
  useEffect(() => {
    // Only run on mobile
    if (window.innerWidth > 768) return;
    
    // Trigger a tiny scroll to encourage address bar collapse
    const triggerScroll = () => {
      if (window.scrollY === 0) {
        window.scrollTo(0, 1);
        setTimeout(() => window.scrollTo(0, 0), 50);
      }
    };
    
    // Run after a short delay to ensure page is loaded
    const timer = setTimeout(triggerScroll, 300);
    
    return () => clearTimeout(timer);
  }, []);
}

